import { useCallback } from 'react'
import { useToast } from '@/contexts/ToastContext'

/**
 * Mensagens consistentes após guardar, remover ou falhar operações no admin/app.
 */
export function useSaveFeedback() {
  const { toast } = useToast()

  const notifySaved = useCallback(
    (message = 'Guardado com sucesso.') => {
      toast(message, 'success')
    },
    [toast]
  )

  const notifyDeleted = useCallback(
    (message = 'Removido com sucesso.') => {
      toast(message, 'success')
    },
    [toast]
  )

  const notifyError = useCallback(
    (error: unknown, fallback = 'Não foi possível guardar. Tente novamente.') => {
      const message = error instanceof Error ? error.message : fallback
      toast(message, 'error')
    },
    [toast]
  )

  const notifyInfo = useCallback(
    (message: string) => {
      toast(message, 'info')
    },
    [toast]
  )

  /** Validação de formulário ou acção bloqueada (toast de erro). */
  const notifyValidation = useCallback(
    (message: string) => {
      toast(message, 'error')
    },
    [toast]
  )

  return { notifySaved, notifyDeleted, notifyError, notifyInfo, notifyValidation, toast }
}

/** Alias para acções gerais (não só «guardar»). */
export const useActionFeedback = useSaveFeedback
